import { AxiosRequestConfig, AxiosResponse } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';
import LotteryTicket from '../../Models/LotteryTicket';
import GetCommissionResponse from '../Responses/CommissionResponse';
import GetLotteryTicketResponse from '../Responses/LotteryTicketResponse';
import GetPaginatedResponse from '../Responses/PaginatedResponse';
import GetResellerResponse from '../Responses/ResellerResponse';

class ResellersApi extends AbstractCRMApi {
    public endpoint: string = 'reseller';

    public getById(resellerId: number, transformStateAndCountryFields: boolean = true): Promise<GetResellerResponse> {
        const params: any = {};
        if (transformStateAndCountryFields) {
            params.transformStateAndCountryFields = '';
        }

        return this.get(`/${resellerId}`, params).then((response: AxiosResponse) => response.data);
    }

    public updateDebit(resellerId: number, debit: number): Promise<GetResellerResponse> {
        return this.patch(`/${resellerId}/reseller_debit`, { reseller_debit: debit }).then(
            (response: AxiosResponse) => response.data
        );
    }

    public getAllCommissions(
        resellerId: number,
        page: number = 1,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<GetCommissionResponse>> {
        return this.get(`/${resellerId}/commissions`, {
            ...config,
            params: { ...config?.params, page },
        }).then((response: AxiosResponse) => response.data);
    }

    public updateCommission(resellerId: number, lotteryId: number, commission: number): Promise<boolean> {
        return this.patch(`/${resellerId}/commissions/${lotteryId}`, { commission }).then(
            (response: AxiosResponse) => response.data
        );
    }

    public getTickets(
        resellerId: number,
        page: number = 1,
        multidrawId?: number,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<LotteryTicket>> {
        return this.get(`/${resellerId}/tickets`, {
            ...config,
            params: {
                ...config.params,
                page,
                multidrawId,
            },
        }).then((response: AxiosResponse<GetPaginatedResponse<GetLotteryTicketResponse>>) => {
            return AbstractCRMApi.mapPaginatedDataToModel(response.data, LotteryTicket);
        });
    }
}

export default new ResellersApi();
